import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <path d="M20,18.4229391 L14.6300716,13.046595 C15.0357995,12.520908 15.3699284,11.9235364 15.6324582,11.30227 C16.0620525,10.2986858 16.2768496,9.22341697 16.2768496,8.12425329 C16.2768496,7.02508961 16.0620525,5.94982079 15.6324582,4.94623656 C15.2267303,3.96654719 14.6300716,3.10633214 13.8902148,2.3655914 C13.150358,1.62485066 12.2673031,1.02747909 11.3126492,0.621266428 C10.3102625,0.215053763 9.23627685,0 8.13842482,0 C7.04057279,0 5.96658711,0.215053763 4.96420048,0.64516129 C3.98568019,1.05137395 3.12649165,1.64874552 2.38663484,2.38948626 C1.64677804,3.130227 1.05011933,4.01433692 0.644391408,4.97013142 C0.214797136,5.97371565 0,7.04898447 0,8.14814815 C0,9.24731183 0.214797136,10.3225806 0.644391408,11.3261649 C1.05011933,12.3058542 1.64677804,13.1660693 2.38663484,13.90681 C3.12649165,14.6475508 4.00954654,15.2449223 4.96420048,15.651135 C5.96658711,16.0812425 7.04057279,16.2962963 8.13842482,16.2962963 C9.23627685,16.2962963 10.3102625,16.0812425 11.3126492,15.651135 C11.9331742,15.3882915 12.5059666,15.0537634 13.0548926,14.6475508 L18.4009547,20 L20,18.4229391 Z M8.125,14.5 C4.64716981,14.5 1.8125,11.6512972 1.8125,8.15625 C1.8125,4.66120283 4.64716981,1.8125 8.125,1.8125 C11.6028302,1.8125 14.4375,4.66120283 14.4375,8.15625 C14.4375,11.6512972 11.6028302,14.5 8.125,14.5 Z"></path>
        </svg>
    );
};

export default React.memo(Search);
